export enum UserStatuses {
    active = 'active',
    expired = 'expired',
    blocked = 'blocked',
    rejected = 'rejected',
    parked = 'parked',
    cancelled = 'cancelled',
}
